/* ============================================
   BeeLive Studio — beelive-configurateur-generation.js  (v2 — data-driven)
   ============================================

   La GÉNÉRATION principale ne se fait plus ici : elle est pilotée par les
   métachamps produit (configurateur_categories + configurateur_quantite + tags).
   Ce fichier ne contient plus que :
     - la config d'AFFICHAGE par profil (pièces avec compteur / extras en bouton)
     - les RÈGLES SPÉCIALES qui ne sont pas exprimables en donnée produit :
         • series      → portes de chambres numérotées (PPM-90155-{n})
         • tableaux    → TTC selon le nb de chambres
         • autocollants→ rouleaux PPM-3030N-*-AR / PPM-3030P-*-AR (baseline + conditionnels)
         • kits        → packs toujours proposés par profil

   ⚠️ Les `id` de pièces/extras DOIVENT être identiques, au caractère près
   (accents/slashs/majuscules), aux valeurs du métachamp `configurateur_categories`.

   ── VARIANTES DE PIÈCE (menu déroulant) ──
   Une pièce peut proposer un choix de TYPE via un menu déroulant. Le code
   sélectionné est généré à la place du pull générique de la catégorie.
     { id:'Toilettes', ..., variants: {
         label: 'Type',
         options: [ { label:'…', code:'PPM-15590-28' }, … ]
     }}
   La quantité du type choisi suit la case « se multiplie » du produit.

   CONDITIONS (tableaux / autocollants) :
     if: { piece: 'Chambre', min: 11 }            // chambres ≥ 11
     if: { piece: 'Chambre', min: 6, max: 10 }    // entre 6 et 10
   ============================================ */

window.BEE_GENERATION_CONFIG = {

  // Codes internes à ne JAMAIS générer (tous profils confondus)
  globalExclude: ['PP00008-1'],

  // Ordre d'affichage des familles dans la liste générée (regroupe les
  // produits de même format côte à côte). Les familles non listées passent
  // après, dans leur ordre d'apparition.
  familyOrder: ['PPM-15590', 'PPM-20050', 'PPM-200300', 'PPM-120120', 'PPM-12030', 'PPM-90155'],

  // Types de toilettes (réutilisé dans chaque profil)
  // (déclaré ici en commentaire pour mémo — défini inline ci-dessous)


  // ═══════════════════════════════════════════════════════════════════════
  // 1. PROPRIÉTAIRE DE GÎTE
  // ═══════════════════════════════════════════════════════════════════════
  gite: {
    label: 'Propriétaire de gîte',
    tag: 'gite',

    pieces: [
      { id: 'Chambre',      label: 'Chambre',       icon: '🛏️', default: 1, max: 20 },
      { id: 'Salon',        label: 'Salon',         icon: '🛋️', default: 1, max: 10 },
      { id: 'Cuisine',      label: 'Cuisine',       icon: '🍳', default: 1, max: 20 },
      { id: 'Salle de bain',label: 'Salle de bain', icon: '🚿', default: 1, max: 20 },
      { id: 'Toilettes',    label: 'Toilettes',     icon: '🚽', default: 1, max: 30,
        variants: { label: 'Type', options: [
          { label: 'Toilettes mixtes (H/F)',  code: 'PPM-15590-28' },
          { label: 'Toilettes hommes',        code: 'PPM-15590-31' },
          { label: 'Toilettes femmes',        code: 'PPM-15590-30' },
          { label: 'Toilettes femmes & PMR',  code: 'PPM-15590-29' },
        ] } },
      { id: 'Buanderie',    label: 'Buanderie',     icon: '🧺', default: 0, max: 10 },
      { id: 'Entrée',       label: 'Entrée',        icon: '🚪', default: 1, max: 10 },
    ],

    extras: [
      { id: 'Circulation',         label: 'Circulation',          icon: '<svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5 12h14\"/><path d=\"m12 5 7 7-7 7\"/></svg>' },
      { id: 'Cinéma',              label: 'Cinéma / Home cinéma', icon: '🎬' },
      { id: 'Piscine',             label: 'Piscine',              icon: '🏊' },
      { id: 'Sauna',               label: 'Sauna',                icon: '🧖' },
      { id: 'Spa',                 label: 'Spa',                  icon: '🛁' },
      { id: 'Espace bien-être',    label: 'Espace bien-être',     icon: '🌿' },
      { id: 'Cave à vin',          label: 'Cave à vin',           icon: '🍷' },
      { id: 'Barbecue',            label: 'Barbecue',             icon: '🔥' },
      { id: 'Bar',                 label: 'Bar',                  icon: '🍺' },
      { id: 'Billard',             label: 'Billard',              icon: '<svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"9\"/><circle cx=\"12\" cy=\"12\" r=\"3.2\"/></svg>' },
      { id: 'Local à vélo',        label: 'Local à vélo',         icon: '🚲' },
      { id: 'Tri sélectif/Ecologie', label: 'Tri sélectif',       icon: '♻️' },
      { id: 'Interdiction de fumer', label: 'Interdiction fumer', icon: '🚭' },
      { id: 'Système de sécurité', label: 'Système de sécurité',  icon: '📷' },
      { id: 'Escalier/Ascenseur',  label: 'Escalier / Ascenseur', icon: '🪜' },
    ],

    series: { trigger: 'Chambre', codeTemplate: 'PPM-90155-{n}', nameTemplate: 'Porte chambre n°{n}', icon: '🛏️', maxN: 20 },

    tableaux: [
      { code: 'PPVEL-TTC-950550-15', if: { piece: 'Chambre', min: 11 } },
      { code: 'PPVEL-TTC-950450-10', if: { piece: 'Chambre', min: 6, max: 10 } },
      { code: 'PPVEL-TTC-950385-5', if: { piece: 'Chambre', min: 2, max: 5 } },
    ],

    autocollants: [
      { code: 'PPM-3030P-1-AR' },
      { code: 'PPM-3030N-1-AR' },
      { code: 'PPM-3030N-1-AR', qty: 2, if: { piece: 'Chambre', min: 1 } },
      { code: 'PPM-3030N-2-AR', qty: 2, if: { piece: 'Chambre', min: 11 } },
    ],

    kits: ['PPM-KIT-H'],
  },


  // ═══════════════════════════════════════════════════════════════════════
  // 2. LOCATION (Airbnb)
  // ═══════════════════════════════════════════════════════════════════════
  airbnb: {
    label: 'Location',
    tag: 'airbnb',

    pieces: [
      { id: 'Chambre',      label: 'Chambre',       icon: '🛏️', default: 1, max: 20 },
      { id: 'Salon',        label: 'Salon',         icon: '🛋️', default: 1, max: 10 },
      { id: 'Cuisine',      label: 'Cuisine',       icon: '🍳', default: 1, max: 20 },
      { id: 'Salle de bain',label: 'Salle de bain', icon: '🚿', default: 1, max: 10 },
      { id: 'Toilettes',    label: 'Toilettes',     icon: '🚽', default: 1, max: 10,
        variants: { label: 'Type', options: [
          { label: 'Toilettes mixtes (H/F)',  code: 'PPM-15590-28' },
          { label: 'Toilettes hommes',        code: 'PPM-15590-31' },
          { label: 'Toilettes femmes',        code: 'PPM-15590-30' },
          { label: 'Toilettes femmes & PMR',  code: 'PPM-15590-29' },
        ] } },
      { id: 'Entrée',       label: 'Entrée',        icon: '🚪', default: 1, max: 10 },
    ],

    extras: [
      { id: 'Circulation',         label: 'Circulation',          icon: '<svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5 12h14\"/><path d=\"m12 5 7 7-7 7\"/></svg>' },
      { id: 'Cinéma',              label: 'Cinéma / Home cinéma', icon: '🎬' },
      { id: 'Piscine',             label: 'Piscine',              icon: '🏊' },
      { id: 'Sauna',               label: 'Sauna',                icon: '🧖' },
      { id: 'Spa',                 label: 'Spa',                  icon: '🛁' },
      { id: 'Espace bien-être',    label: 'Espace bien-être',     icon: '🌿' },
      { id: 'Barbecue',            label: 'Barbecue',             icon: '🔥' },
      { id: 'Billard',             label: 'Billard',              icon: '<svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"9\"/><circle cx=\"12\" cy=\"12\" r=\"3.2\"/></svg>' },
      { id: 'Tri sélectif/Ecologie', label: 'Tri sélectif',       icon: '♻️' },
      { id: 'Interdiction de fumer', label: 'Interdiction fumer', icon: '🚭' },
      { id: 'Système de sécurité', label: 'Système de sécurité',  icon: '📷' },
      { id: 'Local à vélo',        label: 'Local à vélo',         icon: '🚲' },
    ],

    series: { trigger: 'Chambre', codeTemplate: 'PPM-90155-{n}', nameTemplate: 'Porte chambre n°{n}', icon: '🛏️', maxN: 20 },

    tableaux: [],

    autocollants: [
      { code: 'PPM-3030P-1-AR' },
      { code: 'PPM-3030N-1-AR' },
      { code: 'PPM-3030N-1-AR', qty: 2, if: { piece: 'Chambre', min: 1 } },
      { code: 'PPM-3030N-2-AR', qty: 2, if: { piece: 'Chambre', min: 11 } },
    ],

    kits: ['PPM-KIT-H'],
  },


  // ═══════════════════════════════════════════════════════════════════════
  // 3. COLOCATION
  // ═══════════════════════════════════════════════════════════════════════
  coloc: {
    label: 'Colocation',
    tag: 'coloc',

    pieces: [
      { id: 'Chambre',      label: 'Chambre',       icon: '🛏️', default: 3, max: 20 },
      { id: 'Salon',        label: 'Salon',         icon: '🛋️', default: 1, max: 10 },
      { id: 'Cuisine',      label: 'Cuisine',       icon: '🍳', default: 1, max: 20 },
      { id: 'Salle de bain',label: 'Salle de bain', icon: '🚿', default: 1, max: 50 },
      { id: 'Toilettes',    label: 'Toilettes',     icon: '🚽', default: 1, max: 20,
        variants: { label: 'Type', options: [
          { label: 'Toilettes mixtes (H/F)',  code: 'PPM-15590-28' },
          { label: 'Toilettes hommes',        code: 'PPM-15590-31' },
          { label: 'Toilettes femmes',        code: 'PPM-15590-30' },
          { label: 'Toilettes femmes & PMR',  code: 'PPM-15590-29' },
        ] } },
      { id: 'Buanderie',    label: 'Buanderie',     icon: '🧺', default: 0, max: 20 },
      { id: 'Frigo partagé',label: 'Frigo partagé', icon: '🧊', default: 1, max: 20 },
    ],

    extras: [
      { id: 'Circulation',         label: 'Circulation',          icon: '<svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5 12h14\"/><path d=\"m12 5 7 7-7 7\"/></svg>' },
      { id: 'Cinéma',              label: 'Cinéma / Home cinéma', icon: '🎬' },
      { id: 'Cave à vin',          label: 'Cave à vin',           icon: '🍷' },
      { id: 'Billard',             label: 'Billard',              icon: '<svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"9\"/><circle cx=\"12\" cy=\"12\" r=\"3.2\"/></svg>' },
      { id: 'Espace bien-être',    label: 'Espace bien-être',     icon: '🌿' },
      { id: 'Local à vélo',        label: 'Local à vélo',         icon: '🚲' },
      { id: 'Tri sélectif/Ecologie', label: 'Tri sélectif',       icon: '♻️' },
      { id: 'Interdiction de fumer', label: 'Interdiction fumer', icon: '🚭' },
      { id: 'Système de sécurité', label: 'Système de sécurité',  icon: '📷' },
      { id: 'Escalier/Ascenseur',  label: 'Escalier / Ascenseur', icon: '🪜' },
    ],

    series: { trigger: 'Chambre', codeTemplate: 'PPM-90155-{n}', nameTemplate: 'Porte chambre n°{n}', icon: '🛏️', maxN: 20 },

    tableaux: [
      { code: 'PPVEL-TTC-950550-15', if: { piece: 'Chambre', min: 11 } },
      { code: 'PPVEL-TTC-950450-10', if: { piece: 'Chambre', min: 6, max: 10 } },
      { code: 'PPVEL-TTC-950385-5', if: { piece: 'Chambre', min: 2, max: 5 } },
    ],

    autocollants: [
      { code: 'PPM-3030P-1-AR' },
      { code: 'PPM-3030N-1-AR' },
      { code: 'PPM-3030N-1-AR', qty: 2, if: { piece: 'Chambre', min: 1 } },
      { code: 'PPM-3030N-2-AR', qty: 2, if: { piece: 'Chambre', min: 11 } },
    ],

    kits: ['PPM-KIT-H'],
  },


  // ═══════════════════════════════════════════════════════════════════════
  // 4. PARTICULIER
  // ═══════════════════════════════════════════════════════════════════════
  particulier: {
    label: 'Particulier',
    tag: 'particulier',

    pieces: [
      { id: 'Chambre',      label: 'Chambre',       icon: '🛏️', default: 1, max: 10 },
      { id: 'Salon',        label: 'Salon',         icon: '🛋️', default: 1, max: 5 },
      { id: 'Cuisine',      label: 'Cuisine',       icon: '🍳', default: 1, max: 5 },
      { id: 'Salle de bain',label: 'Salle de bain', icon: '🚿', default: 1, max: 5 },
      { id: 'Toilettes',    label: 'Toilettes',     icon: '🚽', default: 1, max: 5,
        variants: { label: 'Type', options: [
          { label: 'Toilettes mixtes (H/F)',  code: 'PPM-15590-28' },
          { label: 'Toilettes hommes',        code: 'PPM-15590-31' },
          { label: 'Toilettes femmes',        code: 'PPM-15590-30' },
          { label: 'Toilettes femmes & PMR',  code: 'PPM-15590-29' },
        ] } },
      { id: 'Buanderie',    label: 'Buanderie',     icon: '🧺', default: 0, max: 5 },
      { id: 'Entrée',       label: 'Entrée',        icon: '🚪', default: 1, max: 5 },
    ],

    extras: [
      { id: 'Cinéma',              label: 'Cinéma / Home cinéma', icon: '🎬' },
      { id: 'Cave à vin',          label: 'Cave à vin',           icon: '🍷' },
      { id: 'Barbecue',            label: 'Barbecue',             icon: '🔥' },
      { id: 'Espace bien-être',    label: 'Espace bien-être',     icon: '🌿' },
      { id: 'Local à vélo',        label: 'Local à vélo',         icon: '🚲' },
      { id: 'Tri sélectif/Ecologie', label: 'Tri sélectif',       icon: '♻️' },
    ],

    // Pas de série de plaques de porte numérotées chez un particulier.
    series: null,

    tableaux: [
      { code: 'PPVEL-TTC-950550-15', if: { piece: 'Chambre', min: 11 } },
      { code: 'PPVEL-TTC-950450-10', if: { piece: 'Chambre', min: 6, max: 10 } },
      { code: 'PPVEL-TTC-950385-5', if: { piece: 'Chambre', min: 2, max: 5 } },
    ],

    autocollants: [
      { code: 'PPM-3030P-1-AR' },
    ],

    kits: ['PPM-KIT-H'],
  },


  // ═══════════════════════════════════════════════════════════════════════
  // 5. ESPACE PROFESSIONNEL
  // ═══════════════════════════════════════════════════════════════════════
  pro: {
    label: 'Espace professionnel',
    tag: 'pro',

    pieces: [
      { id: 'Bureau',           label: 'Bureau',              icon: '💻', default: 1, max: 50 },
      { id: 'Salle de réunion', label: 'Salle de réunion',    icon: '📊', default: 0, max: 30 },
      { id: 'Accueil/Réception',label: 'Accueil / Réception', icon: '🤝', default: 1, max: 30 },
      { id: 'Toilettes',        label: 'Toilettes',           icon: '🚽', default: 1, max: 50,
        variants: { label: 'Type', options: [
          { label: 'Toilettes mixtes (H/F)',  code: 'PPM-15590-28' },
          { label: 'Toilettes hommes',        code: 'PPM-15590-31' },
          { label: 'Toilettes femmes',        code: 'PPM-15590-30' },
          { label: 'Toilettes femmes & PMR',  code: 'PPM-15590-29' },
        ] } },
      { id: 'Cuisine',          label: 'Cuisine / Cafétéria', icon: '🍳', default: 0, max: 20 },
      { id: 'Atelier/Local',    label: 'Atelier / Local',     icon: '🔧', default: 0, max: 20 },
      { id: 'Entrepôt',         label: 'Entrepôt / Stock',    icon: '📦', default: 0, max: 20 },
    ],

    extras: [
      { id: 'Circulation',         label: 'Circulation',          icon: '<svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5 12h14\"/><path d=\"m12 5 7 7-7 7\"/></svg>' },
      { id: 'Salle de projection', label: 'Salle de projection', icon: '🎬' },
      { id: 'Espace bien-être',    label: 'Espace bien-être',     icon: '🌿' },
      { id: 'Local à vélo',        label: 'Local à vélo',         icon: '🚲' },
      { id: 'Tri sélectif/Ecologie', label: 'Tri sélectif',       icon: '♻️' },
      { id: 'Interdiction de fumer', label: 'Interdiction fumer', icon: '🚭' },
      { id: 'Système de sécurité', label: 'Système de sécurité',  icon: '📷' },
      { id: 'Escalier/Ascenseur',  label: 'Escalier / Ascenseur', icon: '🪜' },
    ],

    series: null,
    tableaux: [],

    autocollants: [
      { code: 'PPM-3030P-1-AR' },
    ],

    kits: ['PPM-KIT-E'],
  },

};